export const buildIconClass = (icon) => {
  if (!icon) return '';
  return icon.includes(' ') ? icon : `fas fa-${icon}`;
};

export const getAriaLabel = (ariaLabel, icon) => {
  if (ariaLabel) return ariaLabel;
  if (!icon) return 'Icon button';
  
  // If icon is like 'fas fa-trash', extract 'trash'
  const parts = icon.split('-');
  const name = parts[parts.length - 1];
  return `Button ${name}`;
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/IconButton/utils/iconButtonHelpers.js